import React from 'react';
import LegalPage from './LegalPage';
import { TERMS_MD } from './legalContent';

const TermsOfService = () => (
  <LegalPage markdown={TERMS_MD} />
);

export default TermsOfService;
